import styled from 'styled-components';
import { getSpacingToken, IconName, Stack, Typography } from '@optimus-web/core';
import { TooltippedIcon } from '../../tooltip';

interface FieldSetProps {
    label: React.ReactNode;
    helper?: string;
    children?: React.ReactNode;
    disabled?: boolean;
    style?: React.CSSProperties;
}

export const FieldSet: React.FC<FieldSetProps> = ({ label, helper, disabled, children, ...other }) => (
    <FieldSetContainer className="mews-form-field-set" vertical spacing="100" {...other}>
        <Stack distribution="space-between">
            <Typography textStyle="bodyMediumStrong" as="div">
                {label}
            </Typography>
            {helper ? <TooltippedIcon size="small" value={IconName.Info} tooltip={helper} /> : null}
        </Stack>
        <div>{children}</div>
    </FieldSetContainer>
);

const FieldSetContainer = styled(Stack)`
    margin-top: ${getSpacingToken('500')}px;
    margin-bottom: ${getSpacingToken('500')}px;

    .mews-react-field:first-child & {
        margin-top: 0;
    }

    .mews-react-field:last-child & {
        margin-bottom: 0;
    }
`;
